// import icons from '@assets/icons'
import images from '@/assets/images'
import { getImage } from '@/utils/utils'
import { HTMLAttributes } from 'react'
import './index.less'

type SJAvatarProps = HTMLAttributes<HTMLDivElement> & {
  className?: string
  src?: string
  name?: string
  showName?: boolean
}

const SJAvatar = ({ className, src, name, showName = true, onClick }: SJAvatarProps) => {
  return (
    <div className={`avatar-box ${className ?? ''}`} onClick={onClick}>
      <img className="profile-bg" src={images.profile} alt="" />
      <img className="avatar" src={src ? getImage(src) : images.avatar_default} alt="" />
      {showName && <div className="name">{name || '棋手'}</div>}
      {/* <View className='camere-box' hoverClass='hoverClass' onClick={onClick}>
        <Image className='icon-camere' src={icons.IconCamere}></Image>
      </View> */}
    </div>
  )
}

export default SJAvatar
